import { NegotiationStatusEnum } from './types';

export function negotiationStatusMakerLabel(value: unknown): string {
  if (typeof value === 'string') {
    if (value === NegotiationStatusEnum.PendingPriceUpdate) {
      return 'Please Improve';
    }
  }

  return '';
}

export function negotiationStatusMakerDescription(value: unknown): string {
  if (typeof value === 'string') {
    if (value === NegotiationStatusEnum.PendingPriceUpdate) {
      return 'The client has asked for a better price. You can respond below by sending a new quote.';
    }
  }

  return '';
}
